import React from 'react';
import PropTypes from 'prop-types';

import * as defaultStyles from '../styles';


export default class Heading extends React.PureComponent {
    static propTypes = {
        month: PropTypes.object.isRequired,
    };

    static contextTypes = {
        styles: PropTypes.object,
        nextMonth: PropTypes.func.isRequired,
        prevMonth: PropTypes.func.isRequired,
        setCalendarMode: PropTypes.func.isRequired,
    };

    handleMonthClick() {
        this.context.setCalendarMode('monthSelector');
    }

    render() {
        const {nextMonth, prevMonth} = this.context;
        const {month} = this.props;

        return (
            <div
                style={{
                    height: '2.5em',
                    marginBottom: '.5em',
                }}>
                <button
                    style={{...defaultStyles.button, display: 'inline-block'}}
                    onClick={this.handleMonthClick.bind(this)}>
                    {month.format('jMMMM jYYYY').persian()}
                </button>
                <button
                    type='button'
                    style={{...defaultStyles.button, float: 'right', width: '2em', height: '2em', minWidth: undefined}}
                    title={window.gettext('Previous Month')}
                    onClick={prevMonth}>
                    <i className='fa-arrow-right'></i>
                </button>
                <button
                    type='button'
                    style={{...defaultStyles.button, float: 'left', width: '2em', height: '2em', minWidth: undefined}}
                    title={window.gettext('Next Month')}
                    onClick={nextMonth}>
                    <i className='fa-arrow-left'></i>
                </button>
            </div>
        );
    }
}
